import React from 'react'
import "./Jobapplyshimmer.css"

const Jobapplyshimmer = () => {
  return (
    <div>
      <div>
	<div className="box1">
  <div className="skeleton1">
  	    <div className="skeleton-left">
			<div className="line h17 w40 m10"></div>
			<div className="line w20" ></div>
            <div className="line"></div>
            <div className="line  w75"></div>
			<div className="line h8 w50"></div>
	    </div>
    </div>
  </div>
</div>
    </div>
  )
}

export default Jobapplyshimmer